import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ErrorBookletTest from './ErrorBookletTest';
import ErrorBookletList from './ErrorBookletList';

export default function ErrorBookletView() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedBookletId, setSelectedBookletId] = useState<string | null>(null);

    useEffect(() => {
        const bookletId = searchParams.get('bookletId');
        if (bookletId) {
            setSelectedBookletId(bookletId);
        } else {
            setSelectedBookletId(null);
        }
    }, [searchParams]);

    const handleSelectBooklet = (bookletId: string) => {
        setSelectedBookletId(bookletId);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('bookletId', bookletId);
        setSearchParams(newParams);
    };

    const handleBack = () => {
        setSelectedBookletId(null);
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('bookletId');
        setSearchParams(newParams);
    };

    if (selectedBookletId) {
        return (
            <ErrorBookletTest
                bookletId={selectedBookletId}
                onBack={handleBack}
            />
        );
    }

    return (
        <ErrorBookletList onSelectBooklet={handleSelectBooklet} />
    );
}